import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, Container, Button, Grid } from '@mui/material'; 
import './HeroSection.css';

const HeroSection = () => {
  const handleClick = () => {
    const element = document.getElementById('services-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Box className="hero-section" sx={{ position: 'relative', zIndex: 10 }}>
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 10 }}>
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.2 }}
              style={{ position: 'relative', zIndex: 10 }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  fontWeight: 700,
                  color: '#51A8B1',
                  marginBottom: 2,
                  fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem', lg: '3.5rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Transforming Medical Workflows
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontFamily: 'Barlow, sans-serif',
                  fontWeight: 500,
                  color: '#A8CF45',
                  marginBottom: 3,
                  fontSize: { xs: '1.3rem', sm: '1.8rem', md: '2.3rem', lg: '2.5rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Empowering Healthcare Professionals
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#666',
                  marginBottom: 4,
                  lineHeight: 1.7,
                  fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
                  textAlign: { xs: 'center', md: 'left' },
                  maxWidth: { xs: '100%', md: '90%' },
                  mx: { xs: 'auto', md: 0 },
                }}
              >
                Transforming healthcare through elegant IT solutions that prioritize 
                security, quality, and the human experience. We don't just build software; 
                we craft digital experiences that ease the lives of healthcare professionals.
              </Typography>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleClick}
                  sx={{
                    backgroundColor: '#51A8B1',
                    color: 'white',
                    padding: { xs: '10px 26px', sm: '12px 32px' },
                    fontFamily: 'Barlow, sans-serif',
                    fontWeight: 600,
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                    borderRadius: '8px',
                    textTransform: 'none',
                    boxShadow: '0 4px 12px rgba(81, 168, 177, 0.25)',
                    border: '2px solid transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#449099',
                      boxShadow: '0 6px 20px rgba(81, 168, 177, 0.35)',
                      border: '2px solid #51A8B1',
                      transform: 'translateY(-2px)',
                    },
                    '&:active': {
                      transform: 'scale(0.98)',
                    },
                  }}
                >
                  Discover Our Solutions
                </Button>
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
